import React from 'react'
import { useTranslation } from 'react-i18next'

import { UserMenuOptions as UMO } from 'src/components/UserMenu'

type TItemProps = {
  closeMenu?: () => void
  disabled?: boolean
  onClick?: () => void
  title?: React.ReactNode
}

const Item = (UMO as unknown as { Item: React.ComponentType<TItemProps> }).Item

export type TDownloadZipProps = {
  closeMenu?: () => void
  onClick: () => void
  running?: boolean
}

const DownloadZip = ({
  closeMenu,
  onClick,
  running = false,
}: TDownloadZipProps): JSX.Element => {
  const { t } = useTranslation()
  const handleClick = (): void => {
    if (!running) onClick()
  }

  return (
    <Item
      closeMenu={closeMenu}
      disabled={running}
      onClick={handleClick}
      title={t(
        running
          ? 'alarm_report.export.menu.running'
          : 'alarm_report.export.menu.download',
      )}
    />
  )
}

export default DownloadZip
